<template>
    <b-container fluid="">
        <b-button type="button" id="btn_flotante_agregar_rollos" size="sm" variant="outline-dark"
            v-if="permisos['inventarios.rayo.rollos']?.crear || datos_usuario.parametros.roles.includes('ROOT')"
            @click="abrir_modal_crear_articulo">
            <i class="fas fa-plus"></i> Agregar
        </b-button>
        <b-button type="button" id="btn_flotante_agregar_rollos" size="sm" variant="outline-dark" v-else disabled>
            <i class="fas fa-plus"></i> Agregar
        </b-button>

        <b-row>
            <div class="col-sm-12 mt-2">
                <h3>
                    Tipos de rollo
                </h3>
            </div>
            <div class="col-sm-12 mt-2">
                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 70%;">
                                Nombre
                            </th>
                            <th style="width: 20%;text-align: center;">
                                Tipo
                            </th>
                            <th style="width: 10%;text-align: center;">
                                ...
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in tipos_de_rollo" :key="index">
                            <td>
                                {{ item.nombre }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.tipo }}
                            </td>
                            <td style="text-align: center;">
                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark" 
                                    v-if="permisos['inventarios.rayo.rollos']?.borrar || datos_usuario.parametros.roles.includes('ROOT')"
                                    @click="borrar_registro(item)">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark" v-else disabled>
                                    <i class="fas fa-trash"></i>
                                </b-button>

                                <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                    v-if="permisos['inventarios.rayo.rollos']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')"
                                    @click="abrir_modal_actualizar_articulo(item)">
                                    <i class="fas fa-pen"></i>
                                </b-button>
                                <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                    v-else disabled>
                                    <i class="fas fa-pen"></i>
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-row>

        <Formulario v-if="modal_crear_articulo" v-on:salir="cerrar_modal_crear_articulo"
            v-on:actualizar="obtener_tipos_de_rollo" />

        <Actulizar v-if="modal_actualizar_articulo" :item="item" v-on:salir="cerrar_modal_actualizar_articulo"
            v-on:actualizar="obtener_tipos_de_rollo" />
    </b-container>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import Formulario from './Crear.vue'
    import Actulizar from './Actualizar.vue'
    import { pregunta } from '@/components/functions/alertas.js'

    export default {
        name: 'Lista',
        components: {
            Formulario,
            Actulizar
        },
        computed: {
            ...mapState(['tipos_de_rollo', 'permisos', 'datos_usuario'])
        },
        data() {
            return {
                modal_crear_articulo: false,
                modal_actualizar_articulo: false,
                item: {}
            }
        },
        methods: {
            cerrar_modal_crear_articulo() {
                this.modal_crear_articulo = false
            },
            abrir_modal_crear_articulo() {
                this.modal_crear_articulo = true
            },
            cerrar_modal_actualizar_articulo() {
                this.modal_actualizar_articulo = false
            },
            abrir_modal_actualizar_articulo(item) {
                this.item = item
                this.modal_actualizar_articulo = true
            },
            async borrar_registro(item) {

                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {

                        let f = {
                            api: `tipo-de-rollos/${item.documentId}`,
                        }

                        await this.borrar_data(f)
                        await this.obtener_tipos_de_rollo()

                    }
                })

            },
            ...mapActions(['borrar_data', 'obtener_tipos_de_rollo'])
        }
    }
</script>

<style>
    #btn_flotante_agregar_rollos {
        position: fixed;
        top: 120px;
        right: 15px;
        z-index: 999;
    }
</style>